import React from 'react';
import { BackButton } from './back-button';
import * as styled from './form.styled';

export const Form: React.FC<{ onBack?: () => void }> = ({ children, onBack }) => {
    return (
        <styled.Form>
            {onBack && <BackButton onClick={onBack}></BackButton>}
            {children}
        </styled.Form>
    );
};
